import { Component, OnDestroy, AfterViewInit, Inject, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-braintree-dialog',
    templateUrl: './braintree-dialog.component.html',
    styleUrls: ['./braintree-dialog.component.scss'],
    standalone: false
})
export class BraintreeDialogComponent implements AfterViewInit, OnDestroy {
	instance: any;
	loading: boolean = true;
	paymentOption: string = null;

	constructor(
		public dialogRef: MatDialogRef<BraintreeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private zone: NgZone,
		public appService: AppService,
	) { }


	ngAfterViewInit() {
		this.loading = true;
		this.loadDropin().then(instance => {
			this.instance = instance;
			let that = this;
			instance["on"]('paymentOptionSelected', (event) => {
				that.zone.run(_ => {
					that.onPaymentMethodChanged(event.paymentOption);
				});
			});

			instance["on"]('paymentMethodRequestable', function (event) {
				that.zone.run(_ => {
					if (that.paymentOption == 'card') return;
					that.apply();
				});
			});

			instance["on"]('noPaymentMethodRequestable', function () {
				that.zone.run(_ => {
					let o = 1;
					//setAttribute('disabled', true);
				});				
			});
		}).catch(err => {
			this.appService.alert({ content: err.message }).then(() => {
				this.dialogRef.close();
			});
		}).then(o => {
			this.loading = false;
		});
	}

	onPaymentMethodChanged(pm) {
		this.paymentOption = pm;
	}

	loadDropin() {
		return new Promise((resolve, reject) => {
			let amount = `${this.data.total}`;
			window["braintree"].dropin.create(
				this.data.configuration, (createErr, instance) => {
				if (createErr) {
					reject(createErr)
				} else {
					resolve(instance);
				}
			});
		})
	}

	getPaymentMethod() {
		let that = this;
		return new Promise((resolve, reject) => {
			this.instance.requestPaymentMethod(function (err, payload) {
				if (err) {
					reject(err);
				} else {
					that.getDeviceData().then(deviceData => {
						payload.deviceData = deviceData;
						resolve(payload);
					}).catch(err => {
						if (payload.type == "Venmo") {
							reject(err)
						} else {
							resolve(payload);
						}
					});
				}
			});
		})
	}

	getDeviceData() {
		let braintree = window["braintree"];
		return new Promise((resolve, reject) => {

			braintree.client.create({
				authorization: this.data.clientToken
			}, (err, clientInstance) => {
				if (err) {
					reject();
					return;
				}
				braintree.dataCollector.create({
					client: clientInstance,
					kount: true
				}, (err, dataCollectorInstance) => {
					if (err) {
						reject();
						return;
					}
					resolve(dataCollectorInstance.deviceData);
				});
			});
		});
	}

	ngOnDestroy() {
		this.instance.teardown((err) => {
			if (err) { console.error('An error occurred during teardown:', err); }
		});
	}

	apply() {
		if (!this.instance) return;
		this.getPaymentMethod().then(res => {
			this.dialogRef.close(res);
		}).catch(err => {
			console.error(err);
			//this.appService.alert({ content: err.message }).then(() => { });
		});
	}

	cancel() {
		this.dialogRef.close();
	}

}
